import React from 'react';
import styled from 'styled-components';

const ConfirmationColorSwatchesContainer = styled.div`
    .selected-colors {
        border: 1px solid #efefef;
        border-radius: 5px;

        > .inner-wrap {
            padding: 30px;
            display: flex;
            flex-wrap: wrap;
            margin-bottom: -20px;
            .item-container {
                flex: 0 0 33.33%;
                margin-bottom: 20px;
                .color-box {
                    /* width: 71px;
                            height: 65px; */
                    border: 1px solid #efefef;
                    margin: 0 auto;
                    width: 80%;
                    position: relative;

                    &::after {
                        content: '';
                        display: block;
                        padding-bottom: 100%;
                    }

                    &.with-line {
                        &::before {
                            content: '';
                            position: absolute;
                            border-top: 1px solid #ccc;
                            width: 141%;
                            transform: rotate(45deg);
                            transform-origin: 0% 0%;
                        }
                    }
                }
            }
        }
    }
`;

const ConfirmationColorSwatches = ({ brandedSettings }) => {
    const {
        primary_color,
        secondary_color,
        accent_1,
        accent_2,
        accent_3,
    } = brandedSettings.product_colors;
    return (
        <ConfirmationColorSwatchesContainer>
            <div className="selected-colors">
                <div className="inner-wrap">
                    {/* primary */}
                    {primary_color !== '' ? (
                        <div className="item-container">
                            <div
                                className="color-box"
                                style={{ backgroundColor: primary_color.code }}
                            ></div>
                        </div>
                    ) : (
                        <div className="item-container ">
                            <div className="color-box with-line"></div>
                        </div>
                    )}

                    {/* secondary */}
                    {secondary_color !== '' ? (
                        <div className="item-container">
                            <div
                                className="color-box"
                                style={{
                                    backgroundColor: secondary_color.code,
                                }}
                            ></div>
                        </div>
                    ) : (
                        <div className="item-container">
                            <div className="color-box with-line"></div>
                        </div>
                    )}

                    {/* accent 1 */}
                    {accent_1 !== '' ? (
                        <div className="item-container">
                            <div
                                className="color-box"
                                style={{ backgroundColor: accent_1.code }}
                            ></div>
                        </div>
                    ) : (
                        <div className="item-container">
                            <div className="color-box with-line"></div>
                        </div>
                    )}

                    {/* accent 2 */}
                    {accent_2 !== '' ? (
                        <div className="item-container">
                            <div
                                className="color-box"
                                style={{ backgroundColor: accent_2.code }}
                            ></div>
                        </div>
                    ) : (
                        <div className="item-container">
                            <div className="color-box with-line"></div>
                        </div>
                    )}

                    {/* accent 3 */}
                    {accent_3 !== '' ? (
                        <div className="item-container">
                            <div
                                className="color-box"
                                style={{ backgroundColor: accent_3.code }}
                            ></div>
                        </div>
                    ) : (
                        <div className="item-container">
                            <div className="color-box with-line">
                                <div className="line"></div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </ConfirmationColorSwatchesContainer>
    );
};

export default ConfirmationColorSwatches;
